// WebP-with-PNG-fallback product shot for marketing pages (Task 7.2).
// SSR-safe: no window/document access.

type Props = {
  /** Filename stem under /marketing/ (e.g. "hero-phone"). */
  name: string;
  alt: string;
  width: number;
  height: number;
  /** Hero (and above-the-fold) shots must not lazy-load. */
  priority?: boolean;
  className?: string;
  /** Decorative companion — hides from AT when true. */
  decorative?: boolean;
};

export function MarketingShot({
  name,
  alt,
  width,
  height,
  priority = false,
  className,
  decorative = false,
}: Props) {
  const webp = `/marketing/${name}.webp`;
  const png = `/marketing/${name}.png`;
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img
        src={png}
        alt={decorative ? "" : alt}
        width={width}
        height={height}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className={
          className ??
          "h-auto w-full rounded-2xl border border-line bg-[#f8fafc] shadow-sm"
        }
        {...(decorative ? { "aria-hidden": true as const } : {})}
      />
    </picture>
  );
}
